import { render, staticRenderFns } from "./MasterItem.vue?vue&type=template&id=575b9110&scoped=true"
import script from "./MasterItem.vue?vue&type=script&lang=js"
export * from "./MasterItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575b9110",
  null
  
)

export default component.exports